module.exports = __webpack_public_path__ + "img/dutch_gable.5cb0257b.jpg";